// CCR-CUSTOM (10/10/2026) : fusion du balisage Avis Garantis dans le Product JSON-LD de Shopify.
// Le widget Avis Garantis injecte son propre Product (note + avis) sans "name" et avec un @id relatif
// ("#product") qui ne correspond pas à celui de Shopify dès que l'URL porte ?variant=.
// Google y voit un second produit invalide (Search Console : « Champ "name" manquant ») et n'affiche pas les étoiles.
// On recopie aggregateRating et review dans le Product (ou ProductGroup) de Shopify, puis on retire le bloc incomplet.
// À supprimer quand Avis Garantis publiera un balisage complet.
(() => {
  const hasType = (data, wanted) => {
    if (!data) return false;
    const type = data['@type'];
    return wanted.some(name => type === name || (Array.isArray(type) && type.includes(name)));
  };

  const parse = script => {
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  };

  const merge = () => {
    let mainScript = null;
    let mainData = null;
    const reviewScripts = [];

    document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
      const data = parse(script);
      // Shopify : Product (produit simple) ou ProductGroup (produit à déclinaisons, avec hasVariant).
      if (!hasType(data, ['Product', 'ProductGroup'])) return;
      if (data.name && (data.offers || data.hasVariant) && !mainScript) {
        mainScript = script;
        mainData = data;
      } else if (!data.name && (data.aggregateRating || data.review)) {
        reviewScripts.push({ script, data });
      }
    });

    if (!mainScript || reviewScripts.length === 0) return false;

    reviewScripts.forEach(({ script, data }) => {
      if (data.aggregateRating) mainData.aggregateRating = data.aggregateRating;
      if (data.review) mainData.review = data.review;
      script.remove();
    });
    mainScript.textContent = JSON.stringify(mainData);
    return true;
  };

  const start = () => {
    merge();
    // Le widget peut injecter (ou réinjecter) son balisage après le chargement : on surveille 30 s.
    const observer = new MutationObserver(mutations => {
      const added = mutations.some(mutation =>
        [...mutation.addedNodes].some(node =>
          node.nodeType === 1 && (node.matches?.('script[type="application/ld+json"]') || node.querySelector?.('script[type="application/ld+json"]'))
        )
      );
      if (added) merge();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 30000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
